import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import useRecruiterDashboard from './useRecruiterDashboard';
import BarChartCommonComponent from '../../../../library/SimpleControls/BarChartCommonComponent';

const RecruiterProgramsAvgCTC = () => {
    const { state } = useContext(SmartContext);
    const { getRecruiterProgramsAvgCTC } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterProgramsAvgCTC();
    }, [state.data.searchCriteria.recruiterProgramsAvgCTC]);

    if (isEmpty(state.data?.reportData?.recruiterProgramsAvgCTC))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state.data.reportData.recruiterProgramsAvgCTC} />
        </>
    );
};

export default RecruiterProgramsAvgCTC;
